import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  DoCheck,
} from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Observable, Subscription } from 'rxjs'
import { filter, map, startWith, switchMap, take, tap } from 'rxjs/operators'
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { Router } from '@angular/router'
import { QuoteCartService } from '../../quote/quote-services/quote-cart.service'
import { Product } from '../../../models/product.model'
import {
  ActiveCartFacade,
  Cart,
  OrderEntry,
  PromotionLocation,
  PromotionResult,
} from '@spartacus/cart/base/root'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { BulkServiceService } from '../../bulk-order/bulk-service.service'
import { CommonService } from '../../../shared/services/common.service'
@Component({
  standalone: false,
  selector: 'vs-get-a-quote',
  templateUrl: './get-a-quote-dialog.component.html',
  styleUrls: ['./get-a-quote-dialog.component.scss'],
})
export class GetAQuoteDialogComponent implements OnInit, DoCheck {
  iconTypes = ICON_TYPE

  entry$: Observable<OrderEntry>
  cart$: Observable<Cart>
  loaded$: Observable<boolean>
  increment: boolean
  quoteDialogIdGenrate: Subscription
  productQuoteDialogGenrate: Subscription
  requestQuoteDialogGenrate: Subscription
  orderPromotions$: Observable<PromotionResult[]>
  promotionLocation: PromotionLocation = PromotionLocation.ActiveCart

  quantity = 0
  modalIsOpen = false

  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef

  form: FormGroup = new FormGroup({})

  private quantityControl$: Observable<FormControl>
  product: any
  loggedIn: boolean
  userType: string
  cartId: string
  newData: {
    product: Product
    userType: string
    cartId: string
    type: string
    quantity: number
  }

  constructor(
    protected launchDialogService: LaunchDialogService,
    protected cartService: ActiveCartFacade,
    public router: Router,
    public commonService: CommonService,
    public auth: AuthService,
    public quoteService: QuoteCartService,
    private bulkService: BulkServiceService,
    private globalMessageService: GlobalMessageService
  ) {
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
        if (this.loggedIn) {
          this.userType = 'current'
          this.cartId = sessionStorage.getItem('cartId-current') || undefined
        }
        if (!this.loggedIn) {
          this.userType = 'anonymous'
          this.cartId = sessionStorage.getItem('cartId-anonymous') || undefined
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )

    this.commonService.getProduct.subscribe(
      (product) => {
        this.newData = product
        this.product = product?.product
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    const submitObj = {
      brandName: this.product?.productLine || this.product?.categories[0]?.name,
      brandCode: this.product?.productLine || this.product?.categories[0]?.code,
      comment: '',
      customerRequestedDate: (this.newData['view'] === 'pdp') ? this.product?.committedDate : this.newData['crd'],
      // customerRequestedDate: this.product?.committedDate || new Date(Date.now())
      //   .toISOString().slice(0, 19).replace(/-/g, '/').split('T')[0],
      rfqPartDescription: this.product?.name,
      rfqPartNumber: this.product?.code,
      productType: this.product?.productType || 'PART',
      quantity: this.newData?.quantity || 1,
      reasonForQuote: '',
      serialNumber: '',
      tagNumber: '',
    }

    if (this.product) {
      this.quoteService.recieveCartId.subscribe(
        (cartId) => {
          if (cartId) {
            this.cartId = cartId
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          window.scrollTo(0, 0)
        }
      )
      this.newData.cartId = sessionStorage.getItem('cartId-' + this.userType)
      this.quoteService
        .addProduct(this.newData?.userType, this.newData?.cartId, submitObj)
        .subscribe((success) => {
          if (this.userType === 'current') {
            sessionStorage.setItem('cartStatus-current', 'added')
          }
          if (this.userType === 'anonymous') {
            sessionStorage.setItem('cartStatus-anonymous', 'added')
          }
          return
        })
    }
    this.launchDialogService.data$.subscribe((data) => {})
  }
  /**
   * Returns an observable formControl with the quantity of the cartEntry,
   * but also updates the entry in case of a changed value.
   * The quantity can be set to zero in order to remove the entry.
   */
  getQuantityControl(): Observable<FormControl> {
    if (!this.quantityControl$) {
      this.quantityControl$ = this.entry$.pipe(
        filter((e) => !!e),
        map((entry) => this.getFormControl(entry)),
        switchMap(() =>
          this.form.valueChanges.pipe(
            // tslint:disable-next-line:deprecation
            startWith(null),
            tap((valueChange) => {
              if (valueChange) {
                this.cartService.updateEntry(
                  valueChange.entryNumber,
                  valueChange.quantity
                )
                if (valueChange.quantity === 0) {
                  this.dismissModal('Removed')
                }
              } else {
                this.form.markAsPristine()
              }
            })
          )
        ),
        map(() => this.form.get('quantity') as FormControl)
      )
    }
    return this.quantityControl$
  }

  ngDoCheck() {
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
        if (this.loggedIn) {
          this.userType = 'current'
          this.cartId = sessionStorage.getItem('cartId-current') || undefined
        }
        if (!this.loggedIn) {
          this.userType = 'anonymous'
          this.cartId = sessionStorage.getItem('cartId-anonymous') || undefined
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  quoteValue() {
    this.commonService.getProduct.subscribe(
      (product) => {
        this.newData = product
        this.product = product?.product
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    const submitObj = {
      brandName: this.product?.productLine || this.product?.categories[0]?.name,
      brandCode: this.product?.productLine || this.product?.categories[0]?.code,
      comment: '',
      customerRequestedDate: '',
      // customerRequestedDate: this.product?.committedDate || new Date(Date.now())
      //   .toISOString().slice(0, 19).replace(/-/g, '/').split('T')[0],
      rfqPartDescription: this.product?.name,
      rfqPartNumber: this.product?.code,
      productType: this.product?.productType || 'PART',
      quantity: this.newData?.quantity || 1,
      reasonForQuote: '',
      serialNumber: '',
      tagNumber: '',
    }

    this.quoteService.recieveCartId.subscribe(
      (cartId) => {
        if (cartId) {
          this.cartId = cartId
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    // this.quoteService.getCart(this.cartId, this.userType).subscribe(
    //   (success) => {
    //     this.cartId = success['code'];
    //   })
    this.cartId = sessionStorage.getItem('cartId-' + this.userType)
    this.quoteService
      .addProduct(this.newData?.userType, this.cartId, submitObj)
      .pipe(take(1))
      .subscribe((success) => {
        this.bulkService.quoteDialogId.next(false)
        this.bulkService.productQuoteDialog.next(false)
        this.bulkService.requestQuoteDialog.next(false)
        if (this.userType === 'current') {
          sessionStorage.setItem('cartStatus-current', 'added')
        }
        if (this.userType === 'anonymous') {
          sessionStorage.setItem('cartStatus-anonymous', 'added')
        }
        return
      })
    this.launchDialogService.data$.subscribe((data) => {})
  }

  ngOnInit() {
    this.quoteDialogIdGenrate = this.bulkService.quoteDialogId.subscribe(
      (quoteDialogId) => {
        if (quoteDialogId) {
          this.quoteValue()
        }
      }
    )

    this.productQuoteDialogGenrate =
      this.bulkService.productQuoteDialog.subscribe((productQuoteDialog) => {
        if (productQuoteDialog) {
          this.quoteValue()
        }
      })
    this.requestQuoteDialogGenrate =
      this.bulkService.requestQuoteDialog.subscribe((requestQuoteDialog) => {
        if (requestQuoteDialog) {
          this.quoteValue()
        }
      })
    this.quoteService.recieveCartId.subscribe(
      (cartId) => {
        if (cartId) {
          this.cartId = cartId
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    this.commonService.getProduct.subscribe(
      (product) => {
        this.product = product.product
        this.auth.isUserLoggedIn().subscribe(
          (success) => {
            this.loggedIn = success
            if (this.loggedIn) {
              this.userType = 'current'
              this.cartId =
                sessionStorage.getItem('cartId-current') || undefined
            }
            if (!this.loggedIn) {
              this.userType = 'anonymous'
              this.cartId =
                sessionStorage.getItem('cartId-anonymous') || undefined
            }
          },
          (error) => {
            this.globalMessageService.add(
              error,
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
            window.scrollTo(0, 0)
          }
        )
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  ngOnDestroy() {
    if (this.quoteDialogIdGenrate) {
      this.quoteDialogIdGenrate.unsubscribe()
    }
    if (this.productQuoteDialogGenrate) {
      this.productQuoteDialogGenrate.unsubscribe()
    }
    if (this.requestQuoteDialogGenrate) {
      this.requestQuoteDialogGenrate.unsubscribe()
    }
  }
  private getFormControl(entry: OrderEntry): FormControl {
    if (!this.form.get('quantity')) {
      const quantity = new FormControl(entry.quantity, { updateOn: 'blur' })
      this.form.addControl('quantity', quantity)

      const entryNumber = new FormControl(entry.entryNumber)
      this.form.addControl('entryNumber', entryNumber)
    }
    return this.form.get('quantity') as FormControl
  }

  dismissModal(reason?: any): void {
    if (reason != 'Continue Shopping' && reason != 'Cross click') {
      this.router.navigate(['quote/cart'])
    }
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.GET_A_QUOTE,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
